import { Moon, Sun, Monitor } from "lucide-react";
import { useTheme } from "next-themes";

const cycle = ["dark", "light", "system"] as const;
const labels: Record<string, string> = {
  dark: "Thème sombre",
  light: "Thème clair",
  system: "Thème système",
};

export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const next = () => {
    const idx = cycle.indexOf(theme as (typeof cycle)[number]);
    setTheme(cycle[(idx + 1) % cycle.length]);
  };

  return (
    <button
      onClick={next}
      className="relative inline-flex h-8 w-8 items-center justify-center rounded-md text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors"
      aria-label={labels[theme ?? "system"]}
      title={labels[theme ?? "system"]}
    >
      <Sun className="h-4 w-4 rotate-0 scale-100 transition-transform dark:-rotate-90 dark:scale-0" />
      <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-transform dark:rotate-0 dark:scale-100" />
      {theme === "system" && (
        <Monitor className="absolute h-4 w-4 text-primary" />
      )}
    </button>
  );
}
